<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    <!-- <POSStore ref="posStore"/> -->
    <ShiftStore ref="shiftStore"/>
    <!-- <POSStore ref="posStore"/> -->
    <!-- ///////////////////////////////////////// -->

    <h1>Reconcilliation Report</h1>
    <!-- <p>ℹ️ Info: This report summarizes the transactional data from Moneris.</p> -->
    <GenericDatePeriodSelector storeName="shiftStore" dateKey="week" />
    <GenericDaysSelector storeName="shiftStore" />
    <!-- <ReconcilliationViewSelector storeName="shiftStore" /> -->
    
    <ExportToExcel 
      :tables="['RCGB_Days', 'RCGB_Shifts', 'RMGB_Days', 'RMGB_Shifts', 'WGB_Days', 'WGB_Shifts', ]" 
      bookName="Shift Report"
      storeName="shiftStore"
    />

    <div v-for="location in $locations" :key="location">
      <ReconcilliationTable storeName="shiftStore" :location="location"/>
      <div class="pagebreak"> </div>
    </div>
    
    
  </div>
</template>

<script>
import POSStore from '@/pages/Reports/POS/Stores/POSStore.vue'
import ShiftStore from '@/pages/Reports/Shifts/Stores/ShiftStore.vue'
import ReconcilliationTable from '@/pages/Reports/Reconcilliation/Components/ReconcilliationTable.vue'
import ReconcilliationViewSelector from '@/pages/Reports/Reconcilliation/Components/ReconcilliationViewSelector.vue'

export default {
  name: 'ReconcilliationReport',
  components:{ 
    ReconcilliationTable, 
    ReconcilliationViewSelector, 
    ShiftStore, 
    POSStore,
  },
  provide(){
    return {
      reconcilliationPage: this,
      page: this,
    }
  },
  computed:{
    timestamps(){return this.$refs.shiftStore.timestamps},
  },
  methods:{
  }
}
</script>

<style scoped>

</style>